export default __webpack_public_path__ + "static/media/atalante1.a11bac10.jpg";